(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (function () {
    var KEY = 'flexara_waitlist_confirmation';
    var MESSAGE = 'I just joined the founding list for Flexara Hydration. It’s serious hydration built with sensitive guts in mind. Thought you might want to check it out:';

    function initConfirmation() {
      var root = document.querySelector('[data-flexara-confirmation-share]');
      if (!root) return;
      var state;
      try { state = JSON.parse(window.sessionStorage.getItem(KEY) || 'null'); } catch (error) { return; }
      if (!state || !Number.isFinite(state.createdAt) || Date.now() - state.createdAt > 1800000) return;

      if (!state.socialId) {
        if (!state.pendingEmail) return;
        root.querySelector('h2').textContent = 'Your referral link is not ready yet.';
        root.querySelector('[data-flexara-confirmation-intro]').textContent = 'Your place on the Founding List is confirmed. Please try again in a few minutes for your personal sharing link.';
        root.querySelector('[data-flexara-confirmation-row]').hidden = true;
        root.querySelector('[data-flexara-confirmation-actions]').hidden = true;
        root.querySelector('[data-flexara-confirmation-progress]').hidden = true;
        root.querySelector('[data-flexara-confirmation-retry]').hidden = false;
        root.hidden = false;
        return;
      }

      function render() {
        var url = new URL('https://flexara.com/');
        url.searchParams.set('kid', state.socialId);
        url.searchParams.set('utm_source', 'referral');
        url.searchParams.set('utm_medium', 'share');
        url.searchParams.set('utm_campaign', 'founding_batch');
        var link = url.toString();
        var input = root.querySelector('[data-flexara-confirmation-url]');
        var body = MESSAGE + '\n\n' + link;
        var count = Math.max(0, Number(state.count) || 0);
        var progress = root.querySelector('[data-flexara-confirmation-progress]');
        input.value = link;
        root.querySelector('[data-flexara-confirmation-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(body);
        root.querySelector('[data-flexara-confirmation-sms]').href = (/iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'sms:&body=' : 'sms:?body=') + encodeURIComponent(body);
        root.querySelector('[data-flexara-confirmation-email]').href = 'mailto:?subject=' + encodeURIComponent('Join me on the Flexara Founding List') + '&body=' + encodeURIComponent(body);
        progress.textContent = count >= 10 ? '10-referral milestone reached.' : count >= 3 ? count + ' friends referred. You’ve unlocked $10 toward your first Flexara order.' : count + ' friends referred. Refer 3 friends to unlock $10 toward your first Flexara order.';
        root.hidden = false;
      }

      root.querySelector('[data-flexara-confirmation-copy]').addEventListener('click', function (event) {
        var button = event.currentTarget;
        var input = root.querySelector('[data-flexara-confirmation-url]');
        function copied() {
          button.textContent = 'Copied';
          window.setTimeout(function () { button.textContent = 'Copy link'; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(input.value).then(copied).catch(function () { input.select(); document.execCommand('copy'); copied(); });
        } else {
          input.select();
          document.execCommand('copy');
          copied();
        }
      });

      render();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initConfirmation);
    else initConfirmation();
  })();

  } catch(e) { console.error(e); }
})();
})();
